import { Dispatch, RefObject, SetStateAction, createContext } from "react";
import { Item, ObjectGeneric } from "../../../../../../utils/types/generals";
import { DynamicFormRefValues } from "../../../../../../components/dynamicFormRef/types";
import { ModalState, PermissionsData, TypeMode } from "../../typing/types";
import { CreateQuestionnaire, SectionError, SectionList, UpdataQuestionList, UpdataSecctionData, UserToEndpoint } from "../provider/types";
import { SectionRef } from "../../fragments/section/contextProvider/provider/types";
import { Dayjs } from "dayjs";
import { OptionActionRef, OptionActionSavePayload } from "../../../../components/optionActions/types";
import { Types } from "../../../../../../utils/enums";

const QuestionnaireContext = createContext<{
    setOptionGroup: Dispatch<SetStateAction<Item[]>>
    optionGroup: Item[]
    setOptions: Dispatch<SetStateAction<Item[]>>
    options: Item[]
    dataHeader: DynamicFormRefValues | undefined
    setDataHeader: Dispatch<SetStateAction<DynamicFormRefValues | undefined>>
    modal: ModalState
    setModal: Dispatch<SetStateAction<ModalState>>
    closeModal: () => void
    sectionError: SectionError[]
    updateQuestionList: UpdataQuestionList
    loading: {
        modal: boolean;
    }
    setLoading: Dispatch<SetStateAction<{
        modal: boolean;
    }>>
    updateSectionData: UpdataSecctionData
    setIdSectionIsEditing: Dispatch<SetStateAction<string>>
    isGeneral: boolean
    orderSection: (list: any[]) => void
    totalPoints: string
    setTotalPoints: Dispatch<SetStateAction<string>>
    addSection: () => void
    sectionList: SectionList
    createQuestionnaire: CreateQuestionnaire
    submitPermissions: (data?: {
        response?: boolean;
        payload: PermissionsData | undefined;
    }) => Promise<any>
    removeSection: (payload: {
        id: string;
    }) => void
    refOptions: (payload: {
        element: OptionActionRef | null;
        name: string;
    }) => OptionActionRef | null
    sectionRef: {
        refsByKey: Record<string, SectionRef | null>;
        setRef: (element: SectionRef | null, key: string) => void;
        addRef: (payload: {
            element: SectionRef | null;
            name: string;
        }) => SectionRef | null;
    }
    averagePoints: number
    headerConfig: {
        created: string;
        date: Dayjs;
    }
    totalSectionPoints: Record<string, number>
    setTotalSectionPoints: Dispatch<SetStateAction<Record<string, number>>>
    questionTotal: number
    sectionAmount: ({ id, questionAmount }: {
        id: string;
        questionAmount: number;
    }) => void
    generalconfig?: OptionActionSavePayload
    openConfig: string
    loadings: {
        main: boolean;
        modal: boolean;
        edit: boolean
    }
    snackbar: {
        open: boolean;
        type: Types;
        message: string;
    }
    isSectionConfig: boolean
    closeSnackbar: () => void
    openGeneralConfig: () => void
    saveGeneralConfig: (payload: OptionActionSavePayload) => void
    sectionTotalPoints: ({ id, total }: {
        id: string;
        total: number;
    }) => void
    handleTotalPoints: (payload: {
        totalPoints: number;
        addToAverage?: boolean
    }) => void
    handleNavigate: () => void
}>(Object({}))

export { QuestionnaireContext }